module.exports = __webpack_public_path__ + "img/exam_jan_2025_uw8mry3l.b95f70ce.jpg";